import { REVIEW_STATUS } from '@/constants/reviewStatus'
export default {
  newExpense: state => state.newExpense,
  transactions: state => state.transactions,
  users: state => state.users,
  loadedTransactionsAmount: state => state.transactions.length,
  filters: state => state.filters,
  userSelectedFiltersAmount: state => state.userSelectedFiltersAmount,
  currentPage: state => state.currentPage,
  lastPage: state => state.lastPage,
  totalItems: state => state.totalItems,
  selectedTransactions: state => state.selectedTransactions,
  totalSelectedTransactions: state => state.selectedTransactions.length,
  selectedUsers: state => state.selectedUsers,
  totalSelectedUsers: state => state.selectedUsers.length,
  allSelectedTransactionsAreReviewed: (state, getters) => {
    if (state.selectedTransactions.length > 0) {
      return state.selectedTransactions.every(el => el.reviewStatus.code === REVIEW_STATUS.APPROVED)
    }
    return false
  },
  allSelectedTransactionsAreAccounted: (state, getters) => {
    if (state.selectedTransactions.length > 0) {
      return state.selectedTransactions.every(el => el.accountedAt)
    }
    return false
  },
  allSelectedTransactionsArePersonalExpense: (state, getters) => {
    if (state.selectedTransactions.length > 0) {
      return state.selectedTransactions.every(el => el.isPersonalExpense)
    }
    return false
  },
  allSelectedTransactionsAreCancelled: (state, getters) => {
    if (state.selectedTransactions.length > 0) {
      return state.selectedTransactions.every(el => el.reviewStatus.code === REVIEW_STATUS.CANCELLED)
    }
    return false
  },
  allSelectedTransactionsAreNotReviewed: (state) => {
    if (state.selectedTransactions.length > 0) {
      return state.selectedTransactions.every(el => el.reviewStatus.code !== REVIEW_STATUS.APPROVED)
    }
    return false
  },
  hasMixedTransactionsStatus: (state) => {
    let hasReviewed = state.selectedTransactions.some(el => el.reviewStatus.code === REVIEW_STATUS.APPROVED)
    let hasNotReviewed = state.selectedTransactions.some(el => el.reviewStatus.code !== REVIEW_STATUS.APPROVED)
    return hasReviewed && hasNotReviewed
  },
  allSelectedTransactionsAreLocked: (state) => {
    if (state.selectedTransactions.length > 0) {
      return state.selectedTransactions.every(el => el.lockedAt)
    }
    return false
  },
  selectAllFlag: state => state.selectAllFlag,
  selectedTransactionsBulkAction: state => state.selectedTransactionsBulkAction,
  hasRequestedBulkActionUsers: state => state.selectedUsersBulkAction,
  isLoadingTransactions: state => state.isLoadingTransactions,
  isLoadingNextPageTransactions: state => state.isLoadingNextPageTransactions,
  categorizeStatusList: () => [{ id: 1, name: 'COMPLETED', value: true }, { id: 2, name: 'INCOMPLETED', value: false }],
  userPaymentMethodsFilters: (state) => state.userPaymentMethodsFilters,
  currentTransaction: state => state.currentTransaction,
  currentTransactionSelectedBudgetTagTypes: state => state.currentTransactionSelectedBudgetTagTypes,
  tableColumns: state => state.tableColumns,
  tableUsersColumns: state => state.tableUsersColumns,
  tableExportColumns: state => state.tableExportColumns,
  userPaymentMethods: state => state.userPaymentMethods,
  officePaymentMethods: state => state.officePaymentMethods,
  currentExpenseReceipts: state => state.currentExpenseReceipts,
  isCallingTransactionDashboard: state => state.isCallingTransactionDashboard,
  transactionDashboard: state => state.transactionDashboard,
  isCallingTransactionDashboardWithoutFilters: state => state.isCallingTransactionDashboardWithoutFilters,
  transactionsWithoutFiltersDashboard: state => state.transactionsWithoutFiltersDashboard,
  receiptModalIsOpen: state => state.receiptModalIsOpen,
  transactionReviewBarIsShown: state => state.transactionReviewBarIsShown,
  transactionMissingInfoBarIsShown: state => state.transactionMissingInfoBarIsShown,
  receiptUploadingByDragAndDrop: state => state.receiptUploadingByDragAndDrop,
  transactionTableTotalAmount: (state) => {
    return Math.abs(state.transactions.reduce((sum, { amount }) => sum + amount, 0))
  },
  topBanner: state => state.topBanner,
  expenses: state => state.expenses,
  vatTypes: state => state.vatTypes,
  usersCurrentPage: state => state.usersCurrentPage,
  usersLastPage: state => state.usersLastPage,
  usersTotalItems: state => state.usersTotalItems,
  filteredViews: state => state.filteredViews,
  currentFilteredView: state => state.currentFilteredView,
  filteredViewBaseId: state => state.filteredViewBaseId
}
